module.exports = __webpack_public_path__ + "img/sfondo-pasta-e-broccoli.3cf7b27f.png";